import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMAgent } from "../graphql/mutations";
import {
  LLMEmailCaptureMode,
  LLMThinkingDepth,
  LLMVisibility,
  ModelLLMAgentConditionInput,
  UpdateLLMAgentInput,
  UpdateLLMAgentMutation,
} from "../API";

const isLocalhostAdmin = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

export async function updateLLMAgentAfterEdit(
  values: UpdateLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null
): Promise<GraphQLResult<UpdateLLMAgentMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMAgent, {
      input: {
        id: values.id,
        name: values.name,
        status: values.status,
        description: values.description || "",
        systemInstructions: values.systemInstructions || "",
        systemInstructionsAction: values.systemInstructionsAction || "",
        groupId: values.groupId !== undefined ? values.groupId : "",

        displayTheme: values.displayTheme || "",
        cssUrl: values.cssUrl || "",
        displayTitle: values.displayTitle || "",
        displayStartMessageOrPrompt: values.displayStartMessageOrPrompt || "",
        displayInitialMessageOrPrompt:
          values.displayInitialMessageOrPrompt || "",
        displayPromptTemplate: values.displayPromptTemplate || "",
        displayFollowOnPrompts: values.displayFollowOnPrompts || "",
        displayActions: values.displayActions || "",
        displayWidth: values.displayWidth || "",
        displayHeight: values.displayHeight || "",

        displayPlaceholder: values.displayPlaceholder || "",
        displayHideInitialPrompt: values?.displayHideInitialPrompt ?? true,
        displayShowSaveButton: values?.displayShowSaveButton ?? true,
        displayShowEmailButton: values?.displayShowEmailButton ?? true,
        displayShowCallToAction: values?.displayShowCallToAction ?? false,
        displayCallToActionButtonText:
          values.displayCallToActionButtonText || "Submit",
        displayCallToActionEmailAddress:
          values.displayCallToActionEmailAddress || "",
        displayCallToActionEmailSubject:
          values.displayCallToActionEmailSubject || "Agent CTA Submitted",
        displayScrollToEnd: values?.displayScrollToEnd ?? false,

        data: values.data || "",

        ragQueryLimit: values.ragQueryLimit || 10,
        ragRankLimit: values.ragRankLimit || 5,
        ragIncludeCitations: values.ragIncludeCitations ?? false,
        ragSkipChecksOnContext: values.ragSkipChecksOnContext ?? true,
        ...(isLocalhostAdmin()
          ? { ragShadowRead: (values as any).ragShadowRead ?? false }
          : {}),

        visibility: values?.visibility || LLMVisibility.PUBLIC,

        createConversationOnFirstChat:
          values.createConversationOnFirstChat ?? true,
        customerEmailCaptureMode:
          values.customerEmailCaptureMode || LLMEmailCaptureMode.HIDE,
        customerEmailCapturePlaceholder:
          values.customerEmailCapturePlaceholder ||
          "Please enter your email...",

        injectMemories: values.injectMemories || 0,
        injectKnowledgeGraph: values.injectKnowledgeGraph || 0,
        enableWebSearch: values.enableWebSearch || false,
        linkedFileTypes: (values as any).linkedFileTypes ?? "",
        thinkingDepth: values.thinkingDepth || LLMThinkingDepth.OFF,
        enableRAG: values.enableRAG || false,
        enableMCP: values.enableMCP || false,
        enablePromptCaching: values.enablePromptCaching ?? true,
        compactionPolicy: values.compactionPolicy || "OFF",
        compactionThreshold: values.compactionThreshold ?? 150000,
        curateToolResults: values.curateToolResults ?? false,
        curateAfterTurns: values.curateAfterTurns ?? 4,      },
      ...(condition ? { condition } : {}),
    })
  ) as Promise<GraphQLResult<UpdateLLMAgentMutation>>;
}
